import React, {Component} from 'react';
import { Tabs, Tab, HelpBlock, DropdownButton, MenuItem, Button, Form, FormControl, FormGroup, InputGroup, ControlLabel, Row, Col, Popover, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
// import './Stock.css';
import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup';
import StockStore from '../../stores/StockStore';
import ConfirmPopup from '../../component/element/ConfirmPopup';
import CKAutocomplete from '../../component/element/CKAutocomplete';
import WorkdocStore from '../../stores/WorkdocStore'
import IframeModal from '../../component/element/IframeModal'

class SWTStockOutPopup extends Component {

  constructor(props) {
    super(props)
    this.props.recordType
    this.state = ({ 
      show: false,
      showConfirm: false,
      confirm: false,
      messageConfirm: "",
      description: "",
      request_by: "",
      response_by: "",
      stock_type: this.props.stockType,
      input: [],
      defaultQu: [],
      formValid: [],
      validState: [],
      formValidQu: [],
      validStateQu: [],
      checkBarcode: [],
      checkBarcodeIcon: [],
      set_qu: [],
      barcodeMsg: "",
      barcodeMsgColor: "",
      customerList: [],
      stockApproverList: []
    })

    let {input} = this.state
    input['description'] = "ตัดรายการสต๊อกโดยใบงานหมายเลข "+this.props.workNo

  }

  componentWillReceiveProps(newProps){
    if(newProps.onShow && newProps.onShow!==this.props.onShow){
      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()  
    }
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({customerList:officer})
    })  
  }  

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }  

  onStockOutCancelClick() {
    this.props.onCancel()
    let {input} = this.state
    input['request_by'] = ""
    input['response_by'] = ""
    input['barcode'] = ""
    input['description'] = "ตัดรายการสต๊อกโดยใบงานหมายเลข "+this.props.workNo

    this.setState({checkBarcode:[], checkBarcodeIcon:[], formValid: [], validState: [], formValidQu: [], validStateQu: [], barcodeMsg: "", input:input})
    this.props.onHide()
  }

  onStockOutHideClick(){
    this.setState({ formValid: [], validState: [], barcodeMsg: "" })
    this.props.onHide()
  }

  onSWTNewCustomerClick(e) {
    this.setState({ show: true })
  }

  onCustomerSelect(e) {
    let {input} = this.state
    input['request_by'] = e.name

    let {formValid} = this.state
    let {validState} = this.state
    formValid['request_by'] = ''
    validState['request_by'] = ''

    this.setState({ input: input, formValid:formValid, validState:validState})
  }

  onTextChange(key, e) {
    let {input} = this.state
    input[key] = e.target.value

    let {formValid} = this.state
    let {validState} = this.state
    formValid[key] = ''
    validState[key] = ''

    this.setState({ input: input, formValid:formValid, validState:validState })
  }

  onTextSelect(key, e) {
    let {input} = this.state
    input[key] = e

    this.setState({ input: input })
  }

  onSearchKeyPress(e) {
    if (e.charCode == 13) {

      let {input} = this.state
      let checkBarcode = []
      let checkBarcodeIcon = []

      if (e.target.value != "") {
        for (var i=0;i<this.props.data.length;i++) {
          if (e.target.value==this.props.data[i].productcode) {
            var newColor = "rgba(0, 166, 90, 0.67)"
            this.state.checkBarcode[this.props.data[i].itemnum] = newColor
            this.state.checkBarcodeIcon[this.props.data[i].itemnum] = this.props.data[i].itemnum

            checkBarcode[this.props.data[i].itemnum] = newColor
            checkBarcodeIcon[this.props.data[i].itemnum] = this.props.data[i].itemnum
          }
        }
        if (checkBarcode.length > 0) {
          let msgSuccess = "รหัส "+e.target.value+" ตรวจสอบถูกต้อง"
          this.setState({checkBarcode:this.state.checkBarcode, checkBarcodeIcon:this.state.checkBarcodeIcon, barcodeMsg:msgSuccess, barcodeMsgColor:"rgba(0, 166, 90, 0.67)"})
        } else {
          let {formValid} = this.state
          let {validState} = this.state
          let msgError = "ไม่พบสินค้ารหัส "+e.target.value

          formValid['barcode'] = "formValidationError1"
          validState['barcode'] = "error"
          this.setState({formValid:formValid, validState:validState, barcodeMsg:msgError, barcodeMsgColor:"#dd4b39"})
        }

        input['barcode'] = ""
        this.setState({input:input})
      }  
    }
  }

  getStyleCheckBarcodeIcon(itemnum) {
    let {checkBarcodeIcon} = this.state

    if (checkBarcodeIcon[itemnum]==""||checkBarcodeIcon[itemnum]==undefined) {
      return "none"
    } else {
      return ""
    }
  }

  setFormValid(key) {
    let {formValid} = this.state
    let {validState} = this.state
    formValid[key] = 'formValidationError1'
    validState[key] = 'error'
    this.setState({ formValid:formValid, validState:validState })
  }

  setFormValidQu(key) {
    let {formValidQu} = this.state
    let {validStateQu} = this.state
    formValidQu[key] = 'formValidationError1'
    validStateQu[key] = 'error'
    this.setState({ formValidQu:formValidQu, validStateQu:validStateQu })
  }

  onConfirmStockOutSaveClick(e) {
    console.log("onConfirm")
    let request_by = this.state.input.request_by
    let response_by = this.state.input.response_by
    let description = this.state.input.description

    if (!description) {
      description = ""
    }

    let item = this.props.data.reduce((rresult,element)=>{
      if(element.export_stock_flag==="0"){
        rresult.push({
          itemnum: element.itemnum,
          quantity: element.quantity,
          description: element.description})
      }
      return rresult  
    },[])

    let postData = {}
    postData = {item:item, meta:{description:description,request_by:this.state.input.request_by, response_by:this.state.input.response_by, stock_type:"genpart", record_type:"export", added_date:this.props.date, wo:this.props.workNo}}
    let that = this
    StockStore.exportProduct(this.state.stock_type, postData, function(result) {
      if (result.status == 'OK') {
        let url = './pdf/?sr='+result.id+'&file=stockrecord_doc'
        if (process.env.NODE_ENV == "development") {
          url = 'https://demo2.bigfix.co/korat/pdf/?sr='+result.id+'&file=stockrecord_doc'
        } 
        that.refs.iframe.loadUrl(url)
        if(that.props.onSuccessExport!==undefined)
          that.props.onSuccessExport()
        
        that.onStockOutCancelClick()
      }
    },function(){
      
    }) 

    this.setState({showConfirm:false, messageConfirm:"", confirm:false, input: []})

    // let that = this
    // WorkdocStore.loadWorkdocFixingList(this.props.workNo,function(result){ 
    //   that.refs.partDataGrid.setPartList(result.data.partlist) 
    // })

     
  }

  onStockOutViewClick(e) {
    // window.open('https://demo-fast.bigfix.co/sriracha/pdf/?wo='+this.props.workNo+'&file=stockrecord_doc', '_blank');
    let that = this
    let url = './pdf/?wo=' + this.props.workNo + '&file=stockrecord_doc'
    if (process.env.NODE_ENV == "development") {
      url = 'https://demo-fast.bigfix.co/sriracha/pdf/?wo=' + this.props.workNo + '&file=stockrecord_doc'     
    }
    that.refs.iframe.loadUrl(url)
  }

  onStockOutSaveClick() {
    let request_by = this.state.input.request_by
    let response_by = this.state.input.response_by
    let description = this.state.input.description

    if (!request_by) {
      this.setFormValid('request_by')
      return false
    }

    if (!response_by) {
      this.setFormValid('response_by')
      return false
    }
    
    this.setState({showConfirm:true, messageConfirm:"ต้องการบันทึกรายการหรือไม่?"})
  }

  renderTable() {
    return(
      <div className='display-overflow'>
        <table className="table table-responsive table-hover table-bordered-solid">
          <thead>
            <tr>
              <th className="text-center">ลำดับ</th>
              <th style={{width: "100px"}} className="text-center">รหัสสินค้า</th>
              <th style={{width: "520px"}}>รายการ</th>
              <th style={{width: "100px"}} className="text-center">จำนวน</th>
              <th style={{width: "100px"}} className="text-center">จำนวน<br/>(คลังสินค้า)</th>
              <th style={{width: "100px"}} className="text-center">ตรวจ<br/>บาร์โค้ด</th>
              <th style={{width: "100px"}} className="text-center">ตัด<br/>สต๊อก?</th>
              <th className="text-center">ลบ?</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th className="text-center">ลำดับ</th>
              <th style={{width: "100px"}} className="text-center">รหัสสินค้า</th>
              <th style={{width: "520px"}}>รายการ</th>
              <th style={{width: "100px"}} className="text-center">จำนวน</th>
              <th style={{width: "100px"}} className="text-center">จำนวน<br/>(คลังสินค้า)</th>
              <th style={{width: "100px"}} className="text-center">ตรวจ<br/>บาร์โค้ด</th>
              <th style={{width: "100px"}} className="text-center">ตัด<br/>สต๊อก?</th>
              <th className="text-center">ลบ?</th>
            </tr>
          </tfoot>
          <tbody>
            { this.renderRowData() }  
          </tbody>
        </table>
      </div>  
    );
  }

  onDeleteClick(itemnum, e) {
    this.props.onDelete(itemnum)
  }

  renderRowData() {
    if (this.props.data.length === 0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        this.props.data.map((item, index) => {
          let export_stock_flag = "ยัง"
          if (item.export_stock_flag=="1") {
            export_stock_flag = (<div><FontAwesome name='check' className='text-large'/></div>)
          }
          return(
            <tr key={index} style={{backgroundColor: this.state.checkBarcode[item.itemnum]}}>
              <td className="text-center">{ index + 1 }</td>
              <td className="text-center">{ item.productcode }</td>
              <td>{ item.description }</td>
              <td className="text-center">
                {/*
                <FormGroup
                  controlId={this.state.formValidQu[item.itemnum]}
                  validationState={this.state.validStateQu[item.itemnum]}
                >
                  <FormControl type="number" value={ this.props.defaultQu[item.itemnum] } onChange={ this.onQuantityChange.bind(this, item.itemnum) } className="text-center" />
                </FormGroup>
                */}
                { item.quantity }
              </td>  
              <td className="text-center">
                <FormControl type="text" value={ item.export_quantity } readOnly="" className="input-dark text-center" />
              </td>
              <td className="text-center">
                <FontAwesome name='check' style={{display:this.getStyleCheckBarcodeIcon(item.itemnum)}} />
              </td>
              <td className="text-center">
                { export_stock_flag }
              </td> 
              <td className="text-center" onClick={this.onDeleteClick.bind(this, item.itemnum)}>
                <FontAwesome className="color-red" name='times-circle' />
              </td>    
            </tr>  
          ) 
        })
      )
    }  
  }

  renderCustomerButton(){
    if (this.props.stockType ==="genpart" && this.props.recordType == "export") { 
      return (
        <InputGroup.Addon className="btn"
        onClick={ this.onSWTNewCustomerClick.bind(this) }
      >
        <FontAwesome name='plus' />
      </InputGroup.Addon>
      )
    }else{
      return ('')
    }
  }

  render(){
    return (
      <div>
        <Modal bsSize="large" show={this.props.onShow} onHide={this.onStockOutHideClick.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>
              สร้างรายการเบิกคลังสินค้า
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>เลขที่เอกสาร</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="<เลขที่ถูกสร้างอัตโนมัติ>" className="input-dark" />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>วันที่<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" className="input-dark" value={ this.props.date } />
                  </FormGroup>
                </Col>
              </Row>
              
              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={ this.state.formValid.request_by }
                    validationState={ this.state.validState.request_by }
                  >
                    <ControlLabel>ผู้ขอเบิก<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={ this.state.formValid.request_by }
                    validationState={ this.state.validState.request_by }
                  >
                    {/*<FormControl type="text" placeholder="" value={ this.state.input.request_by } onChange={ this.onTextChange.bind(this, 'request_by') } />*/}
                    <CKAutocomplete
                      items={this.state.customerList}
                      value={this.state.input.request_by}
                      onChange={this.onTextChange.bind(this, 'request_by')}
                      onSelect={this.onTextSelect.bind(this, 'request_by')}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup
                    controlId={ this.state.formValid.response_by }
                    validationState={ this.state.validState.response_by }
                  >
                    <ControlLabel>ชื่อผู้อนุมัติ<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup
                    controlId={ this.state.formValid.response_by }
                    validationState={ this.state.validState.response_by }
                  >
                    {/*<FormControl type="text" placeholder="" value={ this.state.input.response_by } onChange={ this.onTextChange.bind(this, 'response_by') } />*/}
                    <CKAutocomplete
                      items={this.state.stockApproverList}
                      value={this.state.input.response_by}
                      onChange={this.onTextChange.bind(this, 'response_by')}
                      onSelect={this.onTextSelect.bind(this, 'response_by')}
                    />
                  </FormGroup>
                </Col>
              </Row>
              
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>คำอธิบาย</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={10}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={ this.state.input.description } onChange={ this.onTextChange.bind(this, 'description') } />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <FormGroup
                    controlId={ this.state.formValid.barcode }
                    validationState={ this.state.validState.barcode }
                  >
                    <ControlLabel>บาร์โค้ด</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup
                    controlId={ this.state.formValid.barcode }
                    validationState={ this.state.validState.barcode }
                  >
                    <FormControl type="text" placeholder="" value={ this.state.input.barcode } onChange={ this.onTextChange.bind(this, 'barcode') } onKeyPress={this.onSearchKeyPress.bind(this)} />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <p style={{color:this.state.barcodeMsgColor}}>{this.state.barcodeMsg}</p>
                </Col>
              </Row>
              <br/>
              { this.renderTable() }
            </form>      
          </Modal.Body>  
          <Modal.Footer>
            <Button style={{display:this.props.displayBtnStockOutView}} className="btn-default" onClick={ this.onStockOutViewClick.bind(this) }>
              <FontAwesome name='file-o' /> ดูบันทึกรายการที่เบิกแล้ว
            </Button>
            <Button className="btn-primary" onClick={ this.onStockOutSaveClick.bind(this) } disabled={this.props.btnDisabled}>
              <FontAwesome name='save' /> ตัดสต๊อกและบันทึกรายการ
            </Button>
            <Button className="btn-default" onClick={ this.onStockOutCancelClick.bind(this) }>
              <FontAwesome name='remove' /> ยกเลิกรายการ
            </Button>            
          </Modal.Footer>      
        </Modal>
        <SWTNewCustomerPopup 
          show={this.state.show} 
          onHide={()=>{this.setState({show:false})}}
          onSelect={this.onCustomerSelect.bind(this)}
        />
        <ConfirmPopup
          show={this.state.showConfirm}
          message={this.state.messageConfirm}
          onConfirm={this.onConfirmStockOutSaveClick.bind(this)}
          onHide={()=>{this.setState({showConfirm:false})}}
        >
        </ConfirmPopup>
        <IframeModal ref='iframe'  title='พิมพ์เอกสาร' />
      </div>
    )
  }
}


export default SWTStockOutPopup;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTStockOutPopup.js